import React from 'react';
import { Link } from 'react-router-dom';
import medicalBg from '../assets/bb.jpg';
import leftIcon from '../assets/left.png';
import fiImage from '../assets/fi.jpg';
import secImage from '../assets/sec.png';
import thImage from '../assets/th.png';
const vitals = ['MULTI-CENTER', 'CLOUD & ON-PREM', 'OP · IP · EMR', 'BILLING & CLAIMS'];

const capabilities = [
  { img: fiImage, alt: 'Multi-center console interface', title: 'Multi-center console', text: 'One dashboard, every location.' },
  { img: secImage, alt: 'Clinical documentation screen', title: 'Clinical documentation', text: 'OP-IP records, kept in sync.' },
  { img: thImage, alt: 'Secure cloud infrastructure diagram', title: 'Secure by design', text: 'Cloud or on-premise, your call.' },
];

const About = () => {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--ink)]" style={{ fontFamily: 'var(--font-body)' }}>
      {/* Hero */}
      <div className="relative">
        <img src={medicalBg} alt="Drogastro clinic backdrop" className="w-full h-48 md:h-64 object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/95 via-[#2563EB]/30 to-transparent" />

        <Link to="/" className="absolute top-4 left-4 md:top-6 md:left-6 z-10">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/90 shadow-sm hover:bg-white transition-colors">
            <img src={leftIcon} alt="Back" className="w-4 h-4 object-contain" />
          </span>
        </Link>

        <div className="absolute bottom-0 left-0 right-0 px-4 md:px-8 pb-5 md:pb-8">
          <span
            className="inline-block text-[11px] tracking-wider text-[#2563EB] mb-2"
            style={{ fontFamily: 'var(--font-mono)' }}
          >
            ABOUT DROGASTRO
          </span>
          <h1
            className="text-3xl md:text-5xl font-medium text-white tracking-tight"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            Drogastro
          </h1>
          <p className="text-white/85 text-sm md:text-lg mt-2 max-w-xl">
            Clinic management software for the way clinics actually run.
          </p>
        </div>
      </div>

      {/* Vitals strip */}
      <div className="border-b border-[var(--mist)] bg-white sticky top-0 z-10 shadow-sm">
        <div className="container mx-auto px-4 md:px-8 py-3 flex flex-wrap items-center gap-x-6 gap-y-1.5 overflow-x-auto">
          {vitals.map((tag, i) => (
            <span
              key={tag}
              className="flex items-center gap-2 text-[11px] tracking-wider text-[var(--ink)]/70 whitespace-nowrap"
              style={{ fontFamily: 'var(--font-mono)' }}
            >
              {i > 0 && <span className="w-1 h-1 rounded-full bg-[#2563EB]" />}
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Body */}
      <div className="container mx-auto px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12">
          <div className="md:col-span-3 space-y-8">
            <section>
              <p className="text-base md:text-xl leading-relaxed">
                Drogastro is a clinic management platform that runs your core
                financial, clinical, and operational processes in one place —
                from the front desk to the back office.
              </p>
            </section>

            <section>
              <h2
                className="text-xl md:text-2xl font-medium text-[var(--ink)] mb-4"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                Why Drogastro?
              </h2>

              <div className="space-y-5">
                <div className="pl-4 border-l-2 border-[#2563EB] py-1">
                  <h3 className="font-semibold text-[var(--ink)] mb-1">Maximize your investment</h3>
                  <p className="text-sm md:text-base leading-relaxed text-[var(--ink)]/80">
                    Drogastro runs in the browser, so there's no extra licensed
                    software to buy for the operating system or database. Host
                    it on the cloud or on-premise and rely on its multi-center
                    capabilities to scale as you grow.
                  </p>
                </div>

                <div className="pl-4 border-l-2 border-[var(--coral)] py-1">
                  <h3 className="font-semibold text-[var(--ink)] mb-1">Boost staff collaboration</h3>
                  <p className="text-sm md:text-base leading-relaxed text-[var(--ink)]/80">
                    Patient registration, billing, insurance claims and
                    reconciliation, clinical documentation, OP-IP EMR, and
                    inventory management all run seamlessly — with shared data
                    access and better controls behind every clinical outcome.
                  </p>
                </div>
              </div>
            </section>

            <div className="pt-2">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-full shadow-sm transition-colors duration-200"
              >
                Talk to our team →
              </Link>
            </div>
          </div>

          {/* Capability cards */}
          <div className="md:col-span-2 space-y-3">
            <p
              className="text-[11px] tracking-wider text-[var(--ink)]/50 mb-1"
              style={{ fontFamily: 'var(--font-mono)' }}
            >
              CORE CAPABILITIES
            </p>
            {capabilities.map((item) => (
              <div
                key={item.title}
                className="flex items-center gap-3 bg-white rounded-xl border border-[var(--mist)] p-3 hover:border-[#2563EB] hover:shadow-sm transition-all"
              >
                <img src={item.img} alt={item.alt} className="w-16 h-16 object-cover rounded-md shrink-0" />
                <div className="min-w-0">
                  <p className="font-semibold text-sm text-[var(--ink)] truncate">{item.title}</p>
                  <p className="text-xs text-[var(--ink)]/70">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
